import * as actionTypes from "./constants";

const forgotPassword = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FORGOT_PASSWORD_INIT_ACTION,
      params: params,
    });
  };
};

export default {
  forgotPassword,
};
